<template>
  <div class="top-wrapper">
    <div class="top-left">
      <img class="logo" src="../../assets/logo.png"/>
      <span class="logo-text">管理平台</span>
    </div>
    <div class="top-right">
      <span class="user-info">{{user.userName}}</span>
      <el-button
        @click="quit"
        type="text">
        <i class="el-icon-switch-button quit"></i>
      </el-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import { mapGetters } from 'vuex';
  import { logout } from '@/api/user';

  export default {
    name: 'Top',
    methods: {
      quit() {
        const { userId } = this.user;
        logout(userId).then((res) => {
          localStorage.setItem('userId', '');
          localStorage.setItem('phoneNo', '');
          this.$router.push('/login');
        });
      }
    },
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .top-wrapper
    display: flex;
    justify-content: space-between
    .top-left
      .logo
        height: 60px;
        width: 60px;
        display: inline-block;
        vertical-align: middle;
      .logo-text
        margin-left: 20px;
        font-size: 30px;
        display: inline-block;
        vertical-align: middle;
    .top-right
      display: flex;
      align-items: center;
      .user-info
        margin-right: 20px;
        color: #666;
      .quit
        font-size: 20px;
        color: #666;
</style>
